import { IAdminDrawerGroupItem } from "common/types/admin-drawer.types";
import { makeAutoObservable, observable } from "mobx";

export enum GroupItemName {
  HOME = 'Home',
  USER_GROUP_MANAGEMENT = 'User Group Management',
  EVENT_MANAGEMENT = 'Event Management',
  MEMBER_MANAGEMENT = 'Member Management',
  TICKET_MANAGEMENT = 'Ticket Management'
}

export class AdminDrawerStore {
  linkHierarchy = new Map<GroupItemName, IAdminDrawerGroupItem>([
    [
      GroupItemName.HOME,
      {
        groupName: GroupItemName.HOME,
        url: '/admin/home'
      }
    ],

    [
      GroupItemName.USER_GROUP_MANAGEMENT,
      {
        groupName: GroupItemName.USER_GROUP_MANAGEMENT,
        groupItems: [
          {
            name: 'View Employees',
            url: '/admin/user/employees'
          },
          {
            name: 'View User Groups',
            url: '/admin/user/usergroup'
          }
        ]
      }
    ],

    [
      GroupItemName.EVENT_MANAGEMENT,
      {
        groupName: GroupItemName.EVENT_MANAGEMENT,
        groupItems: [
          {
            name: 'Create BPTN Tech Talk',
            url: '/admin/event/create'
          },
          {
            name: 'Create Summit',
            url: '/admin/summit/create',
            altURLs: ['/admin/summit/update'],
          },
          {
            name: 'Event List',
            url: '/admin/event/list'
          }
        ]
      }
    ],

    [
      GroupItemName.MEMBER_MANAGEMENT,
      {
        groupName: GroupItemName.MEMBER_MANAGEMENT,
        groupItems: [
          {
            name: 'Reported Content',
            url: '/admin/reported-content'
          },
          {
            name: 'Reported Users',
            url: '/admin/reported-users'
          }
        ]
      }
    ],

    [
      GroupItemName.TICKET_MANAGEMENT,
      {
        groupName: GroupItemName.TICKET_MANAGEMENT,
        groupItems: [
          {
            name: 'Edit Ticket(s)'
          },
          {
            name: 'View Ticket(s)'
          },
          {
            name: 'Delete Ticket(s)'
          },
          {
            name: 'Create Ticket(s)'
          }
        ]
      }
    ]
  ])

  constructor() {
    makeAutoObservable(this)
  }
}

export const AdminDrawerState = observable(new AdminDrawerStore())
